type AppEnv = 'development' | 'production';

const APP_ENV: AppEnv = (
  (process.env.REACT_APP_APP_ENV || 'development') as AppEnv
).toLowerCase() as AppEnv;

const WATERMARK_DEV_URL = 'http://3.146.154.224:4007';
const WATERMARK_PROD_URL = 'https://watermark.crooklynclan.net';
const isDevUrlApi = (process.env.REACT_APP_URL_API || '').includes('dev');
const resolvedWatermarkUrl = isDevUrlApi
  ? WATERMARK_DEV_URL
  : WATERMARK_PROD_URL;

const configs: Record<AppEnv, any> = {
  development: {
    apiBaseUrl: 'https://be-dev.crooklynclan.net/api',
    hostApi: 'https://be-dev.crooklynclan.net',
    watermarkApiUrl: resolvedWatermarkUrl,
    dropbox: {
      clientId: 'dswpn34kex3r3fy',
      redirectAuth: 'https://app-dev.crooklynclan.net/auth/login',
      redirectDownload: 'https://app-dev.crooklynclan.net/tracks',
    },
    facebookAppId: '753256795820124',
    paypalClientId:
      'AV70ha8X-Tzwd1XXCFDQhsBwUCmGCW5lsiLWvLYoMXtX90ajWma3AbWRM1MEd9paUZ29wubC8qbr6rfI',
    googleMapsApiKey: 'AIzaSyC0SlXbLTkNpwcBbx01BHygVTQkCzG7g5s',
    googleOAuthClientId:
      '524021385401-utqat6cqu6s0i765tlvehernt7mdp4dd.apps.googleusercontent.com',
    spotify: {
      api: 'https://api.spotify.com/v1/',
      tokenUrl: 'https://accounts.spotify.com/api/token',
      clientId: '60f37d27037e4ec7975e332a09e30c0a',
      clientSecret: 'fa8e519ebea44204993614cacd6cee7c',
    },
    youtubeApiKey: 'AIzaSyAho07m0uVP57uKzJee8mrbURT-bcK2emQ',
    youtubeApiUrl: 'https://www.googleapis.com/youtube/v3/',
    rapidApiKey: 'ff12792c27msh788fbf8ce242267p16b5cbjsnb10ab77d023b',
  },
  production: {
    apiBaseUrl: 'https://be.crooklynclan.net/api',
    hostApi: 'https://be.crooklynclan.net',
    watermarkApiUrl: resolvedWatermarkUrl,
    dropbox: {
      clientId: 'dswpn34kex3r3fy',
      redirectAuth: 'https://app.crooklynclan.net/auth/login',
      redirectDownload: 'https://app.crooklynclan.net/tracks',
    },
    facebookAppId: '753256795820124',
    paypalClientId:
      'Acs3-y8ziiS6yaPH7zdzErSwjldRIHR80rI8ELS2w8jrafUaytP7Lgqdjx8q88HYo9trrjstLY_-2taE',
    googleMapsApiKey: 'AIzaSyC0SlXbLTkNpwcBbx01BHygVTQkCzG7g5s',
    googleOAuthClientId:
      '524021385401-utqat6cqu6s0i765tlvehernt7mdp4dd.apps.googleusercontent.com',
    spotify: {
      api: 'https://api.spotify.com/v1/',
      tokenUrl: 'https://accounts.spotify.com/api/token',
      clientId: '60f37d27037e4ec7975e332a09e30c0a',
      clientSecret: 'fa8e519ebea44204993614cacd6cee7c',
    },
    youtubeApiKey: 'AIzaSyAho07m0uVP57uKzJee8mrbURT-bcK2emQ',
    youtubeApiUrl: 'https://www.googleapis.com/youtube/v3/',
    rapidApiKey: 'ff12792c27msh788fbf8ce242267p16b5cbjsnb10ab77d023b',
  },
};

export const appConfig = configs[APP_ENV] || configs.development;
export { APP_ENV };
